const ionic = require('ionic')
const get = require('lodash/get')
const angular = require('angular')
const serverConfig = require('../infrastructure/serverConfig')
const { config: globalConfig, utils: globalUtils } = require('js/global/module')

module.exports = ['$scope', '$rootScope', '$stateParams', 'contactService', '$translate', '$utils', '$ionicPopup', 'User', '$timeout', '$phoneModal', '$state', '$loading', '$cookies', 'WmsvrClient', '$ionicViewSwitcher', 'LocalStorage', '$window',
  function ($scope, $rootScope, $stateParams, contactService, $translate, $utils, $ionicPopup, User, $timeout, $phoneModal, $state, $loading, $cookies, WmsvrClient, $ionicViewSwitcher, LocalStorage, $window) {
    if ($rootScope.settings.disableLoginPage) {
      $state.go('forbid')
    }

    $scope.hideDotting = true
    $scope.selectedLanguage = ''
    $scope.loginParams = {}
    $scope.enableSaveUsername = $rootScope.settings.featureControl.login.enableSaveUsername
    if ($scope.enableSaveUsername) {
      $scope.saveUsername = LocalStorage.getItem('saveUsername')
      if ($scope.saveUsername) {
        $scope.loginParams.uid = typeof LocalStorage.getItem('lastLoginUsername') === 'string' ? LocalStorage.getItem('lastLoginUsername') : ''
      }
    }
    $scope.settingMenu = $rootScope.settings['settingMenu']
    initLanguageSetup()
    addLanguagePanelListener()
    $scope.keyboardShowHandler = function (e) {
      handleKeyboard('show')
    }

    $scope.keyboardHideHandler = function (e) {
      handleKeyboard('hide')
    }
    // 忘记密码
    $scope.goForgetPassword = function() {
      sessionStorage.setItem('forgetPassword_email', $scope.loginParams.uid)
      $state.go('emailValidation')
    }

    // 键盘显示或隐藏
    function handleKeyboard(action) {
      if (ionic.Platform.isAndroid()) {
        $scope.showKeyboard = action == 'show'
        if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
          $scope.$digest()
        }
      }
    }

    /**
     * 登录成功后的操作
     */
    function handleLoginSuccess(sid, params) {
      $scope.closeModal()
      if (params.ssl) {
        location.protocol = 'https:'
      }
      const redirectUrl = decodeURIComponent($stateParams.redirectUrl)
      $state.go('frame.folder', angular.extend({fid: 1, sid}, $state.current.name === 'bindAuth' ? {redirectUrl} : {}))
    }

    /* --------------------------------PUBLIC METHOD--------------------------------- */
    /**
     * 改变语言
     */
    // 读取当前语言设置
    function initLanguageSetup() {
      $scope.languageList = globalConfig.languageList
      const language = $translate.proposedLanguage() || $translate.use()
      $translate.use(language)
      $scope.selectedLanguage = languageType(language)
      $scope.loginParams.locale = language
    }
    // 打开切换语言面板
    $scope.openLanguageOptionsPanel = function() {
      if ($scope.showLanguageOptionsPanel) {
        $scope.showLanguageOptionsPanel = false
      } else {
        LA.track('A0')
        $scope.showLanguageOptionsPanel = true
      }
    }
    // 处理语言选择
    $scope.handleLanguageSelect = function(language) {
      if (language === 'en_US') {
        LA.track('A003')
      } else if (language === 'zh_TW') {
        LA.track('A002')
      } else if (language === 'zh_CN') {
        LA.track('A001')
      }
      $scope.selectedLanguage = languageType(language)
      $scope.openLanguageOptionsPanel()
      $translate.use(language)
      $scope.loginParams.locale = language
    }
    // 根据语言代号获取语言名称
    function languageType(language) {
      const languageList = globalConfig.languageList
      for (let i = 0; i < languageList.length; i++) {
        if (languageList[i].code === language) {
          return languageList[i].name
        }
      }
    }
    // 语言面板他处点击监听
    function addLanguagePanelListener() {
      $scope.optionsPanel = document.getElementsByClassName('select-options')[0]
      document.addEventListener('click', function(event) {
        if (!event.target.classList.contains('select-options') && !event.target.classList.contains('select-language-click') && !event.target.classList.contains('select-language-value') && !event.target.classList.contains('select-language-icon')) {
          $scope.showLanguageOptionsPanel = false
          $scope.$digest()
        }
      })
    }
    // 处理表单值改变
    $scope.handleInputValueChange = function(type) {
      switch (type) {
        case 'uid' :
          $scope.showUidClearIcon = !!$scope.loginParams.uid
          break
        case 'password':
          $scope.showPasswordClearIcon = !!$scope.loginParams.password
          break
        default:
          return null
      }
    }
    // 清除表单值
    $scope.clearInputValue = function(type) {
      switch (type) {
        case 'uid' :
          $scope.loginParams.uid = ''
          $scope.showUidClearIcon = false
          break
        case 'password':
          $scope.loginParams.password = ''
          $scope.showPasswordClearIcon = false
          break
        default:
          return null
      }
    }
    // 处理表单失焦事件
    $scope.handleInputBlur = function(type) {
      $scope.keyboardHideHandler()
    }
    // 处理表单聚焦事件
    $scope.handleInputFocus = function(type) {
      switch (type) {
        case 'uid':
          $scope.showUidClearIcon = !!$scope.loginParams.uid
          break
        case 'password':
          $scope.showPasswordClearIcon = !!$scope.loginParams.password
          break
        default:
          return null
      }
      $scope.keyboardShowHandler()
    }
    // 判断是否需要验证码
    if (serverConfig.getItem('DefaultNeedVerifyCode')) {
      $scope.needVerifyCode = true
    }

    // 更新验证码
    $scope.changeVerifyCode = function () {
      $scope.loginParams.verifyCodeImgSrc = $scope.user.getVerifyCodeImgSrc()
      $scope.loginParams.verifyCode = ''
    }

    $scope.getTempSid = function () {
      const user = $scope.user
      user.getTempSession().then(_ => {
        $scope.changeVerifyCode()
      })
    }

    $scope.showPass = function () {
      $scope.showPassword = !($scope.showPassword || false)
    }

    // 查看是否需要强制图形验证码
    $scope.user = User.newUser({
      locale: $scope.loginParams.locale
    })
    $scope.user.wmsvrClient = new WmsvrClient($scope.user)

    // 判断是否需要加密
    if (~[true, 'true', '1', 1].indexOf(serverConfig.getItem('EnablePasswordKey'))) {
      const user = $scope.user
      user.getTempSession().then(sid => {
        User.updateSid(sid)
        User.getPasswordKey().then(res => {
          $scope.crypt = res.key || {}
          $scope.crypt.sid = res.sid
          // 查看是否强制验证码
          if ($scope.needVerifyCode) {
            $scope.changeVerifyCode()
          }
        }, error => {
          $utils.$notify.set({message: error})
        })
      })
    } else if ($scope.needVerifyCode) {
      $scope.getTempSid()
    }
    // 记住用户名
    $scope.rememberUsername = function() {
      LocalStorage.setItem('saveUsername', !$scope.saveUsername)
      $scope.saveUsername = LocalStorage.getItem('saveUsername')
    }

    /**
     * 用户登录，登录页面操作, isAuthLogin 登录时需要二次认证
     */
    $scope.login = function (isAuthLogin) {
      try {
        $scope.loginContent = $translate.instant('TIPS.SIGNING_IN')
        $scope.hideDotting = false
        if (!$scope.loginParams.uid || !$scope.loginParams.password) {
          throw new Error($translate.instant('LOGIN.PARAM_WRONG'))
        } else {
          if (checkStopLogin()) {
            return
          }
          if ($scope.saveUsername) {
            LocalStorage.setItem('lastLoginUsername', $scope.loginParams.uid)
          }
          const params = getLoginParams()
          if ($scope.crypt) {
            const { n, e } = $scope.crypt
            params.sid = $scope.crypt.sid
            params.password = $utils.$crypt.RSAEncrypt(params.password, n, e.toString())
          }
          if (checkIsNewUser($scope.user, params.uid)) {
            $scope.user = User.newUser({
              email: params.uid,
              password: params.password,
              locale: params.locale
            })
          }
          handleSetAsTrusted(isAuthLogin, function(res) {
            if (typeof res === 'boolean') params.authDevice = res

            $scope.user.login(params).then(sid => {
              handleLoginSuccess(sid, params)
            }, function (reason) {
              $scope.loginFailedReason = reason
              $scope.hideDotting = true
              $scope.loginContent = $translate.instant('OP.LOGIN')
              handleLoginFail(reason)
            })
          }, params)
        }
      } catch (error) {
        $utils.$notify.set({message: error})
      }
    }

    function getLoginParams() {
      const loginParams = {
        sid: $scope.loginParams.tempSid, // tempSid ?
        uid: $scope.loginParams.uid,
        password: $scope.loginParams.password,
        locale: $scope.loginParams.locale || 'zh_CN'
      }

      if ($scope.needVerifyCode) {
        loginParams.verifyCode = $scope.loginParams.verifyCode
      }
      if ($scope.loginParams.dynamicPwd) {
        loginParams.dynamicPwd = $scope.loginParams.dynamicPwd
      }
      if ($scope.loginParams.verifyCellCode) {
        loginParams.verifyCellCode = $scope.loginParams.verifyCellCode
      }

      return loginParams
    }

    function checkIsNewUser(user, userInput) {
      let isNewUser = true
      if (!user || !user.sid) {
        return true
      } else if (user.config) {
        if (!user.config.email) user.config.email = $scope.loginParams.uid
        if (!user.config.pwd) user.config.password = $scope.loginParams.password
        const userEmail = user.config.email
        isNewUser = userEmail != userInput
        if (isNewUser && !$utils.$email.test(userInput)) {
          isNewUser = $utils.$email.parse(userEmail).name != userInput
        }
      }
      return isNewUser
    }

    function checkStopLogin() {
      const authModalId = $scope.secondAuthModal ? $scope.secondAuthModal.id : ''
      if ($scope.loginParams.dynamicPwd) {
        return false
      } else if (!$scope.loginParams.tempSid && authModalId == 'authByApp') {
        $utils.$notify.set({message: $translate.instant('VERIFICATION.AUTH_OR_INPUT_AUTH_CODE')})
        return true
      }
      if ($scope.loginParams.verifyCellCode) {
        return false
      } else if (authModalId == 'authByPhone') {
        $utils.$notify.set({message: $translate.instant('VERIFICATION.INPUT_MSG_CODE')})
        return true
      }
    }

    function handleSetAsTrusted(isAuthLogin, callback) {
      if (isAuthLogin) {
        $ionicPopup.confirm({
          title: $translate.instant('TIPS.SYSTEM_MESSAGE'),
          template: $translate.instant('TIPS.SET_AS_TRUSTED'),
          cancelText: $translate.instant('OP.NOT_SET'),
          okText: $translate.instant('OP.SET_AS_TRUSTED')
        }).then(function (res) {
          callback(res)
        })
      } else {
        callback()
      }
    }

    // 多因子二次验证
    function redirectToLoginJsp(info = {}) {
      const loginParams = getLoginParams()
      const { uid, locale } = loginParams
      const urlPrefix = User.getCurrentUser().wmsvrClient.getWmsvrURLPrefix()
      const redirectUrl = decodeURIComponent($stateParams.redirectUrl)
      const destURL = globalUtils.setQueryParams(
        '/coremail/hxphone/sso.html#/frame/folder/1?sid=$sid$',
        $state.current.name === 'bindAuth' ? {redirectUrl} : {},
        {encode: false}
      )
      const params = {
        sid: info.sid,
        uid,
        destURL,
        locale,
        supportDynamicPwd: true,
        supportLoginDevice: true,
        nodetect: true, // login.jsp 如果不传的话会根据移动端ua重定向到移动模板
        needTransLogin: true, // login.jsp 会尝试使用信任设备重新登录一次
        // onlyValidate2FA: true, // login.jsp 会返回一个完成验证的临时sid供登录
        preset: 1 // 使用预设样式1（白底UI）
      }
      // 模拟login.jsp的代码提交方式
      const formEl = document.createElement('form')
      formEl.action = `${urlPrefix}/login.jsp`
      formEl.method = 'get'
      formEl.style.display = 'none'
      for (const name in params) {
        const tempDOM = document.createElement('input')
        tempDOM.type = 'hidden'
        tempDOM.name = name
        tempDOM.value = params[name]
        formEl.appendChild(tempDOM)
      }
      document.body.appendChild(formEl)
      formEl.submit()
      formEl.parentNode.removeChild(formEl)
    }

    function handleLoginFail(reason) {
      console.log('login-failed reason: ' + JSON.stringify(reason))
      if (reason.data) {
        const code = reason.data.code
        const secondAuthCodes = ['FA_NEED_VERIFY_CELL', 'FA_NEED_DYNAMIC_PWD', 'FA_NEED_VERIFY_EMAIL', 'FA_NEED_BIND_DEVICE']
        if (secondAuthCodes.indexOf(code) !== -1 && Boolean(get($rootScope.globalOptions, 'web.login'))) {
          redirectToLoginJsp(reason.data.var)
          return
        }
        switch (code) {
          case 'FA_INVALID_TEMP_SESSION':
            const user = $scope.user
            $utils.$notify.set({message: $translate.instant('LOGIN.' + code)})
            user.getTempSession().then(function () {
              $scope.user && $scope.changeVerifyCode()
            })
            break
          case 'FA_UNAUTHORIZED':
            handleWrongPwd(reason)
            break
          case 'FA_NEED_VERIFY_CODE':
          case 'FA_INVALID_VERIFY_CODE':
            handleVerifyCode(reason)
            break
          case 'FA_NEED_DYNAMIC_PWD':
          case 'FA_INVALID_DYNAMIC_PWD' :
            handleDynamicPwd(reason)
            break
          case 'FA_INVALID_VERIFY_CELL':
          case 'FA_NEED_VERIFY_CELL':
            handleVerifyCell()
            break
          case 'FA_NEED_BIND_TWO_FACTOR_AUTH':
            handleBindAuthConfirm()
            break
          case 'FA_PASSWORD_MUST_CHANGE':
            handlePasswordChange()
            break
          case 'FA_INVALID_BIND_DEVICE':
            handleInvalidBindDevice()
            break
          case 'FA_NEED_BIND_DEVICE':
            handleNeedBindDevice()
            break
          default:
            $utils.$notify.set({message: $translate.instant('LOGIN.' + code)})
            $scope.user && $scope.changeVerifyCode()
        }
      } else {
        if (reason.status == 0 || reason.status == -1) {
          $utils.$notify.set({message: $translate.instant('TIPS.BAD_NETWORK')})
        }
      }
    }
    function handleInvalidBindDevice() {
      $ionicPopup.alert({
        title: $translate.instant('LOGIN.TITLE_FAILED'),
        template: $translate.instant('LOGIN.FA_INVALID_BIND_DEVICE')
      })
    }
    function handleNeedBindDevice() {
      $ionicPopup.confirm({
        title: $translate.instant('LOGIN.TITLE_FAILED'),
        template: $translate.instant('LOGIN.FA_NEED_BIND_DEVICE'),
        cancelText: $translate.instant('OP.NO'),
        okText: $translate.instant('OP.YES_SINGLE'),
        okType: 'button-default',
        cancelType: 'button-positive'
      }).then(res => res && $scope.login(true))
    }

    function handlePasswordChange() {
      $ionicPopup.confirm({
        template: $translate.instant('LOGIN.PASSWORD_NEED_CHANGE'),
        buttons: [{
          text: $translate.instant('OP.CONFIRM'),
          type: 'button-default'
        }]
      })
    }
    function handleWrongPwd(reason) {
      $utils.$notify.set({message: $translate.instant('LOGIN.' + reason.data.code)})
      $scope.changeVerifyCode()
      $scope.loginParams.verifyCode = ''
    }

    function handleVerifyCode(reason) {
      if ($scope.needVerifyCode && reason.data.code === 'FA_NEED_VERIFY_CODE') {
        reason.data.code = 'FA_UNAUTHORIZED'
      }
      $scope.needVerifyCode = true
      const user = $scope.user
      if (!user.sid) {
        user.getTempSession().then(function () {
          $scope.changeVerifyCode()
        })
      } else {
        $scope.loginParams.verifyCode = ''
        $scope.changeVerifyCode()
      }
      $utils.$notify.set({message: $translate.instant('LOGIN.' + reason.data.code)})
    }

    function handleDynamicPwd(reason) {
      // 二次认证
      const resultData = reason ? reason.data : {}
      const resultVar = resultData['var']
      let user
      if (resultVar && resultVar.type && resultVar.type.toString().toLowerCase() == 'otp') {
        if ($scope.secondAuthModal) {
          $utils.$notify.set({message: $translate.instant('VERIFICATION.WRONG_CODE')})
        } else {
          $scope.authModalContent = 'authByApp.html'
          $scope.secondAuthModal = $phoneModal.fromTemplate(require('views/verification/accountAuth.html'), {
            id: 'authByAPP',
            scope: $scope,
            animation: 'slide-in-up',
            backdropClickToClose: false,
            hardwareBackButtonClose: false,
          })
          $scope.inputSecAuthCode = false
          $scope.loginFailedReason = reason
          user = $scope.user
          user.sid = resultVar.sid
          $scope.secondAuthModal.show()
        }
      } else { // 动态密保
        $scope.needdynamicPwd = true
        user = $scope.user
        $scope.loginParams.verifyCodeImgSrc = user.getVerifyCodeImgSrc()
        $scope.loginParams.verifyCode = ''
        $utils.$notify.set({message: $translate.instant('LOGIN.' + resultData.code)})
      }
    }

    function handleVerifyCell() {
      if ($scope.secondAuthModal) {
        $utils.$notify.set({message: $translate.instant('VERIFICATION.WRONG_CODE')})
        $scope.$broadcast('VERIFICATION.WRONG_CODE')
      } else {
        $scope.loginParams.verifyCellCode = ''
        $scope.authModalContent = 'authByPhone.html'
        $scope.secondAuthModal = $phoneModal.fromTemplate(require('views/verification/accountAuth.html'), {
          id: 'authByPhone',
          scope: $scope,
          animation: 'slide-in-up',
          backdropClickToClose: false,
          hardwareBackButtonClose: false
        })
        $scope.secondAuthModal.show()
      }
    }

    function handleBindAuthConfirm() {
      $scope.tempModal = $phoneModal.fromTemplate(require('views/verification/bindAuthConfirm.html'), {
        scope: $scope,
        animation: 'slide-in-up',
        backdropClickToClose: false,
        hardwareBackButtonClose: false
      })
      $scope.tempModal.show()
    }

    $scope.closeModal = function () {
      $scope.tempModal && $scope.tempModal.remove()
      $scope.secondAuthModal && $scope.secondAuthModal.remove()
      $scope.tempModal = null
      $scope.secondAuthModal = null
      $scope.hideDotting = true
      $scope.loginContent = $translate.instant('OP.LOGIN')
    }

    $scope.$on('VERIFICATION.SET_SEND_CODE_CACHE', function(event, data) {
      Object.keys(data).forEach(function(prop) {
        $scope[prop] = data[prop]
      })
    })
  }]



// WEBPACK FOOTER //
// ./src/js/login/loginCtrl.js